<template>
    <div class="container h-full mx-auto">
  <div class="flex flex-col min-h-full w-full">
    <div class="flex w-full laptop:w-2/3 self-center bg-white p-5 tablet:mt-5">
        <div class="flex flex-col w-full laptop:w-3/4">
            <h1>Quick SMS</h1>
            <div class="field">
                <span class="field-title">Sender</span>
                <input type="text" placeholder="NOMADO OR 3212345678"
                class="rounded p-2 border" />
            </div>

            <div class="field">
                <span class="field-title">Destinations</span>
                <input type="text" placeholder="3228887000,32468.."
                class="rounded p-2 border" />
            </div>
            <div class="field relative">
                <span class="absolute bottom-0 mr-5 text-gray-500 text-sm z-50 right-0">
                    0/1377
                </span>
                <span class="field-title">Message body</span>
                <textarea placeholder="message body"
                class="h-32 p-2 rounded border"
                />
            </div>
            <div class="button-primary mt-5">
                <a href="#" class="button-primary mt-5">Send</a>
            </div>
        </div>
        <div class="hidden rounded shadow p-5 tablet:block flex flex-col bg-white-light ml-5 w-1/4">
            Details regarding cost goes here
        </div>
    </div>
  </div>
    </div>
</template>

<script>
// @ is an alias to /src

export default {
    name: 'sms.quick',
    components: {

    }
};
</script>

<style lang="scss" scoped>
.field {
    @apply flex flex-col mt-5;
}
</style>
